import { Controller } from "@hotwired/stimulus"

// Admin-only bulk selection on the seller products page. Collects the ticked
// product ids and POSTs them to the description-fixture or re-translate
// endpoints. Rendered only for admins / impersonating admins (see the view).
export default class extends Controller {
  static targets = ["checkbox", "bar", "count", "selectAll", "discountInput"]
  static values = { fixUrl: String, translateUrl: String, discountUrl: String }

  toggle() {
    const total = this.checkboxTargets.length
    const n = this.selectedIds().length
    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasBarTarget) this.barTarget.classList.toggle("hidden", n === 0)
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = total > 0 && n === total
      this.selectAllTarget.indeterminate = n > 0 && n < total
    }
  }

  toggleAll(event) {
    const checked = event.currentTarget.checked
    this.checkboxTargets.forEach((cb) => { cb.checked = checked })
    this.toggle()
  }

  clear() {
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.toggle()
  }

  fix(event) {
    this.submit(this.fixUrlValue, event.currentTarget.dataset.confirm)
  }

  translate(event) {
    this.submit(this.translateUrlValue, event.currentTarget.dataset.confirm)
  }

  discount(event) {
    const pct = this.hasDiscountInputTarget ? this.discountInputTarget.value.trim() : ""
    if (pct === "" || isNaN(pct) || Number(pct) < 0 || Number(pct) > 100) {
      window.alert(event.currentTarget.dataset.invalid || "Enter a discount between 0 and 100")
      return
    }
    this.submit(this.discountUrlValue, event.currentTarget.dataset.confirm, { discount: pct })
  }

  submit(url, confirmMessage, extra = {}) {
    const ids = this.selectedIds()
    if (ids.length === 0) return
    if (confirmMessage) {
      const msg = confirmMessage.replace("%{count}", ids.length).replace("%{pct}", extra.discount || "")
      if (!window.confirm(msg)) return
    }

    const form = document.createElement("form")
    form.method = "POST"
    form.action = url
    form.appendChild(this.hidden("authenticity_token", this.csrfToken()))
    ids.forEach((id) => form.appendChild(this.hidden("product_ids[]", id)))
    Object.entries(extra).forEach(([k, v]) => form.appendChild(this.hidden(k, v)))
    document.body.appendChild(form)
    form.submit()
  }

  selectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  hidden(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    return input
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
